import { redo, undo } from 'prosemirror-history'

import { Toolbar } from '#components/Toolbar'
import { buildShortcutTip, detectedPlatform, Keys } from '#hooks/useShortcuts'

const { CMD, SHIFT } = Keys

const undoKeys = [CMD, 'Z']
const redoKeys = detectedPlatform === 'mac' ? [CMD, SHIFT, 'Z'] : [CMD, 'Y']

const undoKeyboardShortcut = buildShortcutTip(undoKeys, detectedPlatform)
const redoKeyboardShortcut = buildShortcutTip(redoKeys, detectedPlatform)

export function UndoRedo() {
  'use memo'

  return (
    <>
      <Toolbar.EditorButton
        command={undo}
        icon="fa-mail-reply"
        tooltip={`Undo (${undoKeyboardShortcut})`}
        focusEditor
      />
      <Toolbar.EditorButton
        command={redo}
        icon="fa-mail-forward"
        tooltip={`Redo (${redoKeyboardShortcut})`}
        focusEditor
      />
    </>
  )
}
